import React from "react";
import MedicationCard from "./cards/medication-card/medication-card";
import './index.scss';
import WidgetUtils from "../utils/widget-utils";
import {VERSION_ONE, VERSION_THREE, VERSION_TWO} from "../widget-types";
import staticMediationV2Data from "./cards/medication-card-v2/staticData.json";
import staticMediationV3Data from "./cards/medication-card-v3/staticData.json";
import InitialContext from "../../../state/static-data/InitialContext";
import {Medication, MedicationV2} from "./types";
import MedicationCardV2 from "./cards/medication-card-v2/medication-card-v2";
import MedicationCardV3 from "./cards/medication-card-v3/medication-card-v3";

const MedicationWidget = () => {
    const medWidgetAttributes = InitialContext.getMedicationPriceEstimationWidgetAttributes();
    const widgetVersion = WidgetUtils.getVersion(medWidgetAttributes);
    const medicationElements = [];
    let medications;

    if (widgetVersion == VERSION_ONE) {
        medications = medWidgetAttributes.medications;
        if (medWidgetAttributes.models !== undefined) {
            medications = medWidgetAttributes.models.medications;
        }

        if (medications.length < 1) {
            return <></>;
        }

        for (let i = 0; i < medications.length; i++) {
            const medication: Medication = medications[i];
            medicationElements.push(
                <MedicationCard medicationId={`medication-${i}`}
                                medication={medication}
                                key={`medication-${i}`}/>)
        }

        return (
            <pui-section class="medication-widget" fullWidth centerlane
                         flowDirection="horizontal"
                         mainAxisArrangement="space-between"
                         secondaryAxisArrangement="center">
                {medicationElements}
            </pui-section>
        )
    }

    //TODO: we need to update HCR backend to use weblab and return version 2 on T1 so it can enter this path.
    //  https://issues.amazon.com/issues/KATARA-SX-5973
    if (widgetVersion == VERSION_TWO) {
        if (!!(medWidgetAttributes.models?.medicationsV2)) {
            medications = medWidgetAttributes.models.medicationsV2;
        } else {
            medications = staticMediationV2Data;
        }

        if (medications.length < 1) {
            return <></>;
        }

        for (let i = 0; i < medications.length; i++) {
            const medication: MedicationV2 = medications[i];
            medicationElements.push(
                <MedicationCardV2 medication={medication} key={`medication-${i}`}/>)
        }

        return (
            <pui-section class="medication-widget" fullWidth centerlane
                         flowDirection="horizontal"
                         mainAxisArrangement="space-between"
                         secondaryAxisArrangement="center">
                {medicationElements}
            </pui-section>
        )
    }

    if (widgetVersion == VERSION_THREE) {
        if (!!(medWidgetAttributes.models?.medicationsV3)) {
            medications = medWidgetAttributes.models.medicationsV3;
        } else {
            medications = staticMediationV3Data;
        }

        if (medications.length < 1) {
            return <></>;
        }

        return (
            <MedicationCardV3 medications={medications}/>
        )
    }

    return <></>;
}
export default MedicationWidget;
